// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"aa599a12","162":"8de75d5a","192":"20d2da47","369":"39b28b10","400":"501ef1aa","480":"ea54eea8","675":"94690089","769":"c9ae6ad6"}[chunkId] + ".chunk.js";
};